import Axios from 'axios'
import mainConfig from './server_config/main'
import { userStore } from '@/store/user'

export const MessageMap: {
    [key: string]: string
} = {}

export interface IRequestError {
    message: string
    code: string
}

export class Fetch {
    public static getData(config: any) {
        const instance = Axios.create(config)

        // 添加单次请求的拦截器
        instance.interceptors.request.use(...config.reqInterceptor)
        instance.interceptors.response.use(...config.repInterceptor)

        return instance.request(config)
    }

    public post<T, P>(data: { url: string; params?: P }): Promise<T | any> {
        const serverConfig = {
            url: data.url,
            method: 'post',
            headers: {
                Authentication: userStore.token,
                ShopAuthentication: localStorage.getItem('shopId'),
                'LS-Source': 'App',
            },
            data: data.params, // qs.stringify(data.params)
        }

        return Fetch.getData(Object.assign({}, mainConfig, serverConfig))
    }
}

export const $fetch = new Fetch()

export const $post = $fetch.post
